import { createAction, props, union } from '@ngrx/store';
import {
  RetrieveAuthorizationVerbiageResponseV1,
  SerializableMap,
  TransactionAuthorizationResult,
} from '@arc/unified-payments-frontend/shared-payment';

export const bankAuthorizationVerbiageUpdated = createAction(
  '[POI Payment - Review Payment] Bank Authorization Verbiage Updated',
  props<{
    payload: RetrieveAuthorizationVerbiageResponseV1;
  }>(),
);

export const paymentExecuted = createAction(
  '[POI Payment - Review Payment] Payment Executed',
  props<{
    transactionResults: SerializableMap<TransactionAuthorizationResult>;
  }>(),
);

export const sensitiveInformationCleared = createAction(
  '[POI Payment - Review Payment] Sensitive Information Cleared',
);

export const checkPaymentStatusCompleted = createAction(
  '[POI Payment - Review Payment] Check Payment Status Completed',
  props<{
    results: SerializableMap<TransactionAuthorizationResult>;
    checkStatusCount: number;
    checkStatusTimeout: boolean;
    authorizationPending: boolean;
  }>(),
);

export const checkPaymentStatusErrorAction = createAction(
  '[POI Payment - Review Payment] Check Payment Status Error',
);

export const checkPaymentStatusTimedOutAction = createAction(
  '[POI Payment - Review Payment] Check Payment Status Timed Out',
  props<{
    results: SerializableMap<TransactionAuthorizationResult>;
  }>(),
);

export const checkPaymentStatusCanceledAction = createAction(
  '[POI Payment - Review Payment] Check Payment Status Canceled',
);

const PoiBtPayReviewPaymentActions = union({
  bankAuthorizationVerbiageUpdated,
  paymentExecuted,
  checkPaymentStatusCompleted,
});

export type PoiBtPayReviewPaymentActionsUnion =
  typeof PoiBtPayReviewPaymentActions;
